import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'

import { classes, UnitStyle } from './style'
import { setFeature } from '../../../../actions/viewerActions'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import NotImage from '../../../../components/notImage'
import IconsDetails from '../../../../components/iconsDetails'
import Divider from '@mui/material/Divider'
import UnitFooter from '../../../../components/unitFooter'
import numeral from 'numeral'
import ImageSpinner from '../../../../components/imageSpinner'

const UnitDetails = ({ unit }) => {
  const dispatch = useDispatch()
  const Head = () => {
    return unit.image
      ? <ImageSpinner className={classes.image} url={unit.image}/>
      : <NotImage/>
  }

  const Body = () => {
    const price = `$${numeral(unit.price).format('0,0.00')}`
    return (
      <div className={classes.toolBarContent}>
        <div>
          <br/>
          <Typography variant="h5" fontWeight="bold" align="center" className={classes.bodyTitle}>{price}</Typography>
          <br/>
          <Divider />
          <IconsDetails unit={unit}/>
          <Divider />
          <br/>
          <Typography variant="body2" fontWeight="bold" className={classes.bodyContent}>
            {unit.countyName
            }
          </Typography>
          <Typography variant="caption" fontWeight="medium" className={classes.bodyContent}>
            {unit.buildingAddress}, {unit.stateName}
          </Typography>
          <br/>
          <br/>
          <Link to={'/viewer/' + unit.buildingID + '/unit/' + unit.id} style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              disabled={!unit.available}
              className={classes.detailsBtn}
              onClick={() => {
                dispatch(setFeature(unit))
              }}
            >
              More Details
            </Button>
          </Link>
          <br/>
        </div>
      </div>
    )
  }

  return (
    <UnitStyle className={classes.root}>
      <Head/>
      <Body/>
      <UnitFooter unit={unit}/>
    </UnitStyle>
  )
}

UnitDetails.propTypes = {
  unit: PropTypes.object
}

// eslint-disable-next-line react/prop-types
const Unit = ({ unit }) => <UnitDetails unit={unit}/>

export default Unit
